// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1vgvi","crossIcon":"styles_crossIcon__2LSTR","content":"styles_content__2QvLi","video":"styles_video__3BDZr"};